import request from '@/utils/request'

// 所有销售渠道
export const listSaleChannelAll = () => {
    return request.get(`/goods/saleChannel`)
}
